<app-page-detail [id]="id" [crud]="service" [(model)]="model" [(form)]="form" [reload]="reload" [canDelete]="false">
  <div class="flex flex-column md:flex-row gap-3 w-full justify-content-around p-3">
    <app-editable-card title="Anagrafica" class="md:w-4">
      <app-text-field label="Parametro" [value]="model()?.parametro"></app-text-field>
      <app-text-field label="Definizione" [value]="model()?.definizione"></app-text-field>
      <app-text-field label="Unità di misura" [value]="model()?.unitaDiMisura"></app-text-field>
      <app-text-field label="Precisione Decimale" [value]="model()?.precisioneDecimale==1 ? 'non definita' : (!model()?.precisioneDecimale ? '1' : model()?.precisioneDecimale)"></app-text-field>
     
      <app-text-field label="Note" [value]="model()?.note"></app-text-field>
      <app-boolean-field label="Codificato" [value]="model()?.isCodificato"></app-boolean-field>
      <div card-form>
        <app-new-form [form]="form"></app-new-form>
      </div>
    </app-editable-card>
    <app-editable-card title="Range" class="md:w-8">
      <div>
        <app-range-field label="Range di controllo valido dal GG-MM-AAAA" minLimit="0" min="0" max="100" maxLimit="100"></app-range-field>
      </div>
   <!--    <div>...storico dei range...</div> -->
      <div card-form>
        edit Range
      </div>
    </app-editable-card>
  </div>
</app-page-detail>
